import { frontendURL } from '../../../helper/URLHelper';
import { CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions';
import { FEATURE_FLAGS } from '../../../featureFlags';
import KanbanRoute from './KanbanRoute.vue';

const KanbanBoard = () => import('./KanbanBoard.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.KANBAN,
  permissions: [
    'administrator',
    'agent',
    'custom_role',
    ...CONVERSATION_PERMISSIONS,
  ],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    component: KanbanRoute,
    children: [
      { path: '', name: 'kanban_board', meta, component: KanbanBoard },
      {
        path: ':boardKey',
        name: 'kanban_board_by_key',
        meta,
        component: KanbanBoard,
      },
    ],
  },
];
